import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Grid,
  Card,
  makeStyles,
  CardContent,
  Table,
  TableBody,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import { fetchEmandateStatisticsPayment } from "shared/api/emandate";
import moment from "moment";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import Spin from "components/ui/Spin";

const style = makeStyles((theme) => ({
  table: {
    marginBottom: "20px",
    "& tbody:nth-child(even)": {
      backgroundColor: Colors["lighterPurple"],
    },
  },
}));

const TABLE_HEADER = {
  Date: "date",
  Pending: "pending_count",
  Initiate: "initiate_count",
  "Soft Failed": "soft_failed_count",
  Failed: "failed_count",
  Captured: "captured_count",
  Total: "total",
};

const StatisticsPaymentsTable = (props) => {
  const classes = style();
  const { data,title } = props;
  return (
    <CardContent>
      <span className="common_title">{title}</span>
      <TableContainer className="common_X_scroll">
        <Table className={classes.table}>
          <TableBody>
            <TableRow>
              {Object.keys(TABLE_HEADER).map((header, idx) => (
                <TableHeaderCell key={idx} headerTitle={header} />
              ))}
            </TableRow>
          </TableBody>
          {data?.map((item,index) => {
            return (
              <TableBody key={index}>
                <TableRow>
                  <>
                    {Object.keys(TABLE_HEADER).map((header, idx) => (
                      <TableHeaderCell
                        key={idx}
                        headerTitle={item[TABLE_HEADER[header]] || "-"}
                      />
                    ))}
                  </>
                </TableRow>
              </TableBody>
            );
          })}
        </Table>
      </TableContainer>
    </CardContent>
  );
};

const TableHeaderCell = ({ headerTitle }) => {
  return (
    <TableBodyCell className="common_table_title">{headerTitle}</TableBodyCell>
  );
};

const StatisticsPayments = (props) => {
  const classes = style();

  const [spinning, setSpinning] = useState(false);
  const [statisticsPaymentsData, setStatisticsPaymentsData] = useState([]);

  useEffect(() => {
    statisticsPayments();
  }, []);

  const statisticsPayments = async () => {
    setSpinning(true);
    let todayDate = new Date();
    let formattedDate = moment(todayDate).format("YYYY-MM-DD");
    const response = await fetchEmandateStatisticsPayment(formattedDate);
    try {
      if (response.hasOwnProperty("success") && response.success) {
        setStatisticsPaymentsData(response?.data?.emandate);
      }
      setSpinning(false);
    } catch (error) {
      console.log(error);
      setSpinning(false);
    }
  };

  const { open } = props;
  return (
    <Spin spinning={spinning}>
      <Header open={open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={10}>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <BreadcrumbsHeader text="Statistics Payments" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div className="common_padding_from_title"></div>
      <Card
        style={{ boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}` }}
        className={classes.card}
      >
        <CardContent className="disburse_statistic_content p-1">
          <Grid container>
            <Grid item lg={9} md={9} sm={12} xs={12}>
              <Grid item xs={12}>
                {
                  <StatisticsPaymentsTable
                    title="emandate payment statistics"
                    data={statisticsPaymentsData?.emandate_payment_statistics || []}
                  />
                }
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Spin>
  );
};
export default StatisticsPayments;
